import React from 'react';
import { useTranslation } from '../../../../context/LanguageContext';
import InputField from '../../../form/InputField';
import CheckboxField from '../../../form/CheckboxField';
import SelectField from '../../../form/SelectField';

const DeliveryTab = ({ settings, handleChange }) => {
    const { t, isRTL } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.deliveryConfig')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <CheckboxField
                        label={t('admin.enableDelivery')}
                        checked={settings.delivery?.enabled || false}
                        onChange={(e) => handleChange('delivery', 'enabled', e.target.checked)}
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.deliveryFee')}
                            value={settings.delivery?.fee || 0}
                            type="number"
                            onChange={(e) => handleChange('delivery', 'fee', parseFloat(e.target.value))}
                        />
                        <SelectField
                            label={t('admin.feeType')}
                            value={settings.delivery?.fee_type || 'fixed'}
                            onChange={(e) => handleChange('delivery', 'fee_type', e.target.value)}
                            options={[
                                { value: 'fixed', label: t('admin.fixed') },
                                { value: 'percentage', label: t('admin.percentage') }
                            ]}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.minOrderAmount')}
                            value={settings.delivery?.min_order_amount || 0}
                            type="number"
                            onChange={(e) => handleChange('delivery', 'min_order_amount', parseFloat(e.target.value))}
                        />
                        <InputField
                            label={t('admin.maxDeliveryDistance')}
                            value={settings.delivery?.max_distance || 0}
                            type="number"
                            onChange={(e) => handleChange('delivery', 'max_distance', parseFloat(e.target.value))}
                            helperText={t('admin.maxDeliveryDistanceHelp')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeliveryTab;
